import "./createtest.css"
import firebase from "../../api/config";
import { useEffect, useState } from "react";
const auth = firebase.auth()
const db = firebase.firestore();

export default function CreateTest() {
    
    console.log(auth.currentUser);

    const [questioninfo, setQuestioninfo] = useState([{ index: "", choice1: "", choice2: "", choice3: "", choice4: "", question: "", answer: "" }]);
    const [testName, setTestName] = useState("");
    const [testDuration, setTestDuration] = useState("");

    const handleTestNameChange = (e)=>{
        e.preventDefault();
        setTestName(e.target.value);
    }
    const handleTestDurationChange = (e)=>{
        e.preventDefault();
        setTestDuration(e.target.value);
    }

    const handleTextChange = (e, index) => {
        e.preventDefault();
        const { name, value } = e.target;
        const list = [...questioninfo];
        list[index][name] = value;
        setQuestioninfo(list);
    }

    const handleFieldAdd = (e) => {
        e.preventDefault();
        setQuestioninfo([...questioninfo, { index: "", choice1: "", choice2: "", choice3: "", choice4: "", question: "", answer: "" }])
    }

    const handleFieldRemove = (index) => {
        const list = [...questioninfo];
        list.splice(index, 1);
        setQuestioninfo(list);
    }

    const checkEmpty = () => {
        for (var j = 0; j < questioninfo.length; j++) {
            let obj = questioninfo[j];
            if (obj.index === "" || obj.choice1 === "" || obj.choice2 === "" || obj.choice3 === "" || obj.choice4 === "" || obj.question === "" || obj.answer === "") {
                return true;
            }
        }
        return false;
    }

    const submitList = async (e) => {
        if (checkEmpty()) {
            alert("Please fill all the fields");
        } else {
            db.collection('test/demo-test/msat').doc('testInfo').update({
                /* [`Q${q}`]: ques.answer, */
                duration: testDuration,
                quesNum: questioninfo.length
            })
            questioninfo.forEach((ques)=>{
                let q = parseInt(ques.index) + 1;
                db.collection('test/demo-test/msat').doc('questions').update({
                    [`Q${q}`]: {
                        question: ques.question,
                        choices: [ques.choice1, ques.choice2, ques.choice3, ques.choice4],
                        index: q,
                    }
                })

                db.collection('test/demo-test/msat').doc('key').update({
                    [`Q${q}`]: ques.answer,
                })

            });
            
            
        }
    }

   /*  useEffect(() => {
        console.log(testName, testDuration);
        
    }, [testName, testDuration]) */

    return (
        <>
            <div className="createTest">
                <div className="createTestWrapper">
                    <input required type="text" name="testName" placeholder="Test Name" className="inp10" value={testName} onChange={handleTestNameChange}/>
                    <input required type="text" name="testDuration" placeholder="Test Duration" className="inp10" value={testDuration} onChange={handleTestDurationChange}/>
                    {
                        questioninfo.map((val, i) => {
                            return (
                                <>
                                    <div className="createField" key={i} >
                                        <input required type="text" name="index" placeholder="index" className="inp10" value={val.index} onChange={e => handleTextChange(e, i)} />
                                        <input required type="text" name="question" placeholder="Question" className="inp10" value={val.question} onChange={e => handleTextChange(e, i)} />
                                        <input required type="text" name="choice1" placeholder="Choice 1" className="inp10" value={val.choice1} onChange={e => handleTextChange(e, i)} />
                                        <input required type="text" name="choice2" placeholder="Choice 2" className="inp10" value={val.choice2} onChange={e => handleTextChange(e, i)} />
                                        <input required type="text" name="choice3" placeholder="Choice 3" className="inp10" value={val.choice3} onChange={e => handleTextChange(e, i)} />
                                        <input required type="text" name="choice4" placeholder="Choice 4" className="inp10" value={val.choice4} onChange={e => handleTextChange(e, i)} />
                                        <input required type="text" name="answer" placeholder="Correct Answer" className="inp10" value={val.answer} onChange={e => handleTextChange(e, i)} />

                                        {questioninfo.length - 1 !== 0 && <input type="button" value="Remove" className="inpbtn" onClick={() => handleFieldRemove(i)} />}
                                        {questioninfo.length - 1 === i && <input type="button" value="Add" className="inpbtn" onClick={handleFieldAdd} />}
                                    </div>
                                </>
                            )
                        })
                    }

                    <button onClick={submitList} className="submitBtn">Submit</button>
                </div>
            </div>
        </>
    )
}